// generated from 52_725 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const nestedCustomAttributesFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("nested_custom_attributes_filter"),
  // undefined: 52_723 (100.00%), defined 2 (0.00%)
  blocklisted: z.literal(true).optional(),
  comparison_key: z.string(),
  display_name: z.string(),
  // undefined: 12_389 (23.50%), defined 40_336 (76.50%)
  raw_value: z
    .union([
      // array samples: 6_812 (16.89%)
      z.array(
        z.object({
          comparator: z.string(),
          // undefined: 6 (0.03%), defined 17_923 (99.97%)
          key: common.uuid.optional(),
          path: z.string(),
          value: z.union([
            // boolean samples: 1_648 (9.19%)
            // true 969 (58.80%), false 679 (41.20%)
            z.boolean(),
            // number samples: 5_148 (28.71%)
            // integer: 5_059 (98.27%)
            // avg: 9548566.46, min: -6, max: 8336043390
            z.number(),
            // string samples: 11_133 (62.09%)
            z.string(),
          ]),
        })
      ),
      // object samples: 33_524 (83.11%)
      z.object({
        // null: 94 (0.28%)
        nested_property_name: z.string().nullable(),
        nested_property_value: z.union([
          // boolean samples: 4_514 (13.46%)
          // true 3_520 (77.98%), false 994 (22.02%)
          z.boolean(),
          // number samples: 4_906 (14.63%)
          // integer: 4_839 (98.63%)
          // avg: 4925223.45, min: -5, max: 8195958130
          z.number(),
          // string samples: 12_716 (37.93%)
          z.string(),
          // array samples: 11_388 (33.97%)
          z.array(z.string()),
        ]),
      }),
    ])
    .optional(),
  value: z.union([
    // array samples: 9_955 (18.88%)
    z.array(
      z.object({
        comparator: z.string(),
        // undefined: 13 (0.06%), defined 23_543 (99.94%)
        key: common.uuid.optional(),
        path: z.string(),
        value: z.union([
          // boolean samples: 1_796 (7.62%)
          // true 1_086 (60.47%), false 710 (39.53%)
          z.boolean(),
          // number samples: 7_002 (29.72%)
          // integer: 6_913 (98.73%)
          // avg: 7020413.27, min: -6, max: 8336043390
          z.number(),
          // string samples: 14_758 (62.65%)
          z.string(),
        ]),
      })
    ),
    // object samples: 42_770 (81.12%)
    z.object({
      // null: 141 (0.33%)
      nested_property_name: z.string().nullable(),
      nested_property_value: z.union([
        // boolean samples: 8_097 (18.93%)
        // true 6_188 (76.42%), false 1_909 (23.58%)
        z.boolean(),
        // number samples: 6_442 (15.06%)
        // integer: 6_359 (98.71%)
        // avg: 4004843.17, min: -5, max: 8195958130
        z.number(),
        // string samples: 15_988 (37.38%)
        z.string(),
        // array samples: 12_243 (28.63%)
        z.array(z.string()),
      ]),
    }),
  ]),
  varies_by_app_group: z.literal(true),
});
